import logService from '../wss/logService3';
import { publish } from './pubsub';
import { events } from '../wss/SystemEvents';

/**
 * jxLogger — factory-equivalent of CoreBase.logDebug/logError (services/engines/CoreBase.js),
 * usable ANYWHERE — class components, functional components, plain modules. NOT a hook: holds
 * no React state, calls no hooks internally, so it doesn't need to follow hook rules (can be
 * called once in a class constructor and stored, or called ad-hoc inline, or used in a function
 * component). Renamed from useJxLogger (2026-07-09) — that name implied hook-only usage, which
 * was never actually true given the implementation.
 *
 * Same underlying mechanism as the class version: logService (console output, PROD-gated) +
 * publish(events.onError, ...) for ErrorEngine — no second logging path alongside it.
 *
 * @param {string} name - identifies the source in the log line, same role as this._name in CoreBase
 *   (e.g. 'UmlCanvas', 'UmlShapeWidgetBase').
 * @returns {{ logDebug: (method: string, message: string) => void, logError: (method: string, message: string) => void }}
 */
export default function jxLogger(name) {
    const logDebug = (method, message) => {
        logService.log(`${name}.${method}: ${message}`);
    };

    const logError = (method, message) => {
        const msg = `${name}.${method}: ${message}`;
        logService.logError(msg);
        publish(events.onError, { source: name, message: msg });
    };

    return { logDebug, logError };
}
